var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0 d-flex align-start",
              class: { "mt-md-n10": !_vm.noMarginTop },
              attrs: { cols: "12", sm: "12", md: _vm.showFilters ? 4 : 2 },
            },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFilters,
                      expression: "showFilters",
                    },
                  ],
                  staticClass: "pb-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mx-0 pt-2",
                      attrs: { id: "player-seasons" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 header-font py-2",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.filters")))]
                          ),
                          _vm._v(" "),
                          _vm.currentUser.clientType === "Media" ||
                          _vm.currentUser.clientType === "Driblab"
                            ? _c("MediaModeForm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFilters,
                                    expression: "showFilters",
                                  },
                                ],
                                attrs: {
                                  fields: _vm.mediaModeFields,
                                  mediaMode: _vm.mediaMode,
                                  mediaModeData: _vm.mediaModeData,
                                  selectorMode: "",
                                },
                                on: {
                                  mediaModeChange: function ($event) {
                                    return _vm.onMediaModeChange($event)
                                  },
                                  mediaModeDataChange: function ($event) {
                                    return _vm.onMediaModeDataChange($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12", md: "8" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("table.clientLeagues.seasons")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-autocomplete", {
                            ref: "autoCompleteSeasonRef",
                            attrs: {
                              items: _vm.playerSeasonData,
                              "item-value": "compoundId",
                              "item-text": "compoundText",
                              clearable: "",
                              multiple: "",
                              "hide-details": "",
                              dense: "",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.onSeasonBlur()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function ({ item, index }) {
                                  return [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass:
                                          "body-2 mb-1 w-90 black--text",
                                        attrs: {
                                          small: "",
                                          color: "lightSecondary lighten-2",
                                        },
                                      },
                                      [
                                        _c(
                                          "object",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold text-ellipsis",
                                          },
                                          [_vm._v(_vm._s(item.seasonName))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "mx-1" }, [
                                          _vm._v("@"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-medium" },
                                          [_vm._v(_vm._s(item.teamName))]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    index === 3
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text body-2 subheader-font",
                                          },
                                          [
                                            _vm._v(
                                              "(+" +
                                                _vm._s(
                                                  _vm.seasonDataSelectedModel
                                                    .length - 3
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("finishingMap.more")
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass:
                                          "pa-0 primary--text body-2 font-weight-medium d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "object",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "d-flex flex-column" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.seasonName) +
                                                "\n                    "
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.teamName)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.seasonDataSelectedModel,
                              callback: function ($$v) {
                                _vm.seasonDataSelectedModel = $$v
                              },
                              expression: "seasonDataSelectedModel",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-1 pl-1",
                          attrs: { cols: "12", md: "4" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "pa-0 mr-0 body-1 font-weight-bold primary--text flex-shrink-0",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("general.filter")) +
                                  " " +
                                  _vm._s(_vm.$t("searchbar.games"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 flex-shrink-1" },
                            [
                              _c("v-autocomplete", {
                                staticClass: "pa-0 body-2 mb-2",
                                attrs: {
                                  clearable: "",
                                  "hide-details": "",
                                  dense: "",
                                  items: _vm.grounds,
                                  "item-text": "name",
                                  "item-value": "id",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onSelectChange()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function ({ item, index }) {
                                      return [
                                        index <= 0
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass:
                                                  "body-2 mb-1 w-80 d-flex justify-center black--text",
                                                attrs: {
                                                  small: "",
                                                  color:
                                                    "lightSecondary lighten-2",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text-ellipsis",
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(_vm._s(item.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.groundModel,
                                  callback: function ($$v) {
                                    _vm.groundModel = $$v
                                  },
                                  expression: "groundModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "pa-0 mr-4 body-1 font-weight-bold primary--text flex-shrink-0",
                            },
                            [_vm._v(_vm._s(_vm.$t("searchbar.games")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 flex-shrink-1" },
                            [
                              _c("v-autocomplete", {
                                staticClass: "pa-0 body-2 mb-2",
                                attrs: {
                                  clearable: "",
                                  multiple: "",
                                  "menu-props": "auto",
                                  "hide-details": "",
                                  dense: "",
                                  items: _vm.gamesFiltered,
                                  "item-text": "name",
                                  "item-value": "gameId",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: { ripple: "" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                              },
                                              click: _vm.toggleGames,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "py-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "body-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "finishingMap.selectAll"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selection",
                                    fn: function ({ item, index }) {
                                      return [
                                        index <= 0
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass:
                                                  "body-2 mb-1 black--text",
                                                attrs: {
                                                  small: "",
                                                  color:
                                                    "lightSecondary lighten-2",
                                                },
                                              },
                                              [
                                                _c(
                                                  "object",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`,
                                                      type: "image/png",
                                                      height: "20",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                        height: "20",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text-ellipsis",
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "object",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`,
                                                      type: "image/png",
                                                      height: "20",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                        height: "20",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text body-2 subheader-font",
                                              },
                                              [
                                                _vm._v(
                                                  "(+" +
                                                    _vm._s(
                                                      _vm.gamesModel.length - 1
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.more"
                                                      )
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "object",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(_vm._s(item.name)),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "object",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.gamesModel,
                                  callback: function ($$v) {
                                    _vm.gamesModel = $$v
                                  },
                                  expression: "gamesModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _vm.$vuetify.breakpoint.smAndDown
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex pb-3 pl-0 justify-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "monospace-font px-4",
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showShotOptions = !_vm.showShotOptions
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.showShotOptions
                                          ? _vm.$t(
                                              "game.detail.hidePassOptions"
                                            )
                                          : _vm.$t(
                                              "game.detail.showPassOptions"
                                            )
                                      ) +
                                      " "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showShotOptions
                                            ? "keyboard_arrow_up"
                                            : "keyboard_arrow_down"
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        {
                          staticClass: "px-2",
                          attrs: { id: "passing-location" },
                        },
                        [
                          _vm.showShotOptions
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex pt-0 pb-0 pl-1",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-4 py-0 mt-2 mb-n2 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("general.visualization"))
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showShotOptions
                            ? _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-wrap pt-0 pb-2 pl-1",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "px-4 py-0",
                                    attrs: {
                                      label: _vm.$t("finishingMap.circles"),
                                      color: "secondary",
                                      value: "circles",
                                      "hide-details": "",
                                    },
                                    on: { change: _vm.updateShots },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.circles"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      561737895
                                    ),
                                    model: {
                                      value: _vm.checkboxCircles,
                                      callback: function ($$v) {
                                        _vm.checkboxCircles = $$v
                                      },
                                      expression: "checkboxCircles",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "px-4 py-0 pl-0",
                                    attrs: {
                                      label: _vm.$t("finishingMap.boxes"),
                                      color: "secondary",
                                      value: "boxes",
                                      "hide-details": "",
                                    },
                                    on: { change: _vm.updateShots },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.boxes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3586374085
                                    ),
                                    model: {
                                      value: _vm.checkboxCircles,
                                      callback: function ($$v) {
                                        _vm.checkboxCircles = $$v
                                      },
                                      expression: "checkboxCircles",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "px-2", attrs: { id: "action-ending" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-0 pb-0",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("game.gameThreat.typeOfPlay")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap pt-0 pb-2 pl-1",
                                      attrs: { cols: "12" },
                                    },
                                    _vm._l(
                                      _vm.typeOfPlay,
                                      function (typesPlay, index) {
                                        return _c("v-checkbox", {
                                          key: index,
                                          staticClass: "px-4 py-0",
                                          class: { "pl-0": index % 2 === 1 },
                                          attrs: {
                                            label: typesPlay.text,
                                            color: "secondary",
                                            value: typesPlay.value,
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.updateShots()
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(typesPlay.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.typeOfPlayModel,
                                            callback: function ($$v) {
                                              _vm.typeOfPlayModel = $$v
                                            },
                                            expression: "typeOfPlayModel",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-0 pb-0",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("game.gameThreat.actionEnding")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap pt-0 pb-2 pl-5",
                                      attrs: { cols: "12" },
                                    },
                                    _vm._l(
                                      _vm.actionEndings,
                                      function (actionEnding, index) {
                                        return _c("v-checkbox", {
                                          key: index,
                                          staticClass: "py-0 me-5",
                                          class: { "pl-0": index % 2 === 1 },
                                          attrs: {
                                            label: _vm.$t(
                                              `game.gameThreat.${actionEnding}`
                                            ),
                                            color: "secondary",
                                            value: actionEnding,
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.updateShots()
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `game.gameThreat.${actionEnding}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.actionEndingsModel,
                                            callback: function ($$v) {
                                              _vm.actionEndingsModel = $$v
                                            },
                                            expression: "actionEndingsModel",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "px-2", attrs: { id: "filters" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pt-0 pb-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("general.period")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _vm.showShotOptions
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex flex-wrap pt-0 pb-2 pl-1",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "px-4 py-0",
                                            attrs: {
                                              label:
                                                _vm.$t("general.firstHalf"),
                                              color: "secondary",
                                              value: "period1",
                                              "hide-details": "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.updateShots()
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "general.firstHalf"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3581771750
                                            ),
                                            model: {
                                              value: _vm.periods,
                                              callback: function ($$v) {
                                                _vm.periods = $$v
                                              },
                                              expression: "periods",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-checkbox", {
                                            staticClass: "px-4 py-0 pl-0",
                                            attrs: {
                                              label:
                                                _vm.$t("general.secondHalf"),
                                              color: "secondary",
                                              value: "period2",
                                              "hide-details": "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.updateShots()
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "general.secondHalf"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1931206316
                                            ),
                                            model: {
                                              value: _vm.periods,
                                              callback: function ($$v) {
                                                _vm.periods = $$v
                                              },
                                              expression: "periods",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.showShotOptions && _vm.hasFirstOT
                                            ? _c("v-checkbox", {
                                                staticClass: "px-4 py-0",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "general.firstPeriodOT"
                                                  ),
                                                  color: "secondary",
                                                  value: "period3",
                                                  "hide-details": "",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateShots()
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-1 primary--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "general.firstPeriodOT"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  2642105819
                                                ),
                                                model: {
                                                  value: _vm.periods,
                                                  callback: function ($$v) {
                                                    _vm.periods = $$v
                                                  },
                                                  expression: "periods",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showShotOptions && _vm.hasSecondOT
                                            ? _c("v-checkbox", {
                                                staticClass: "px-4 py-0 pl-0",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "general.secondPeriodOT"
                                                  ),
                                                  color: "secondary",
                                                  value: "period4",
                                                  "hide-details": "",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateShots()
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-1 primary--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "general.secondPeriodOT"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1873983217
                                                ),
                                                model: {
                                                  value: _vm.periods,
                                                  callback: function ($$v) {
                                                    _vm.periods = $$v
                                                  },
                                                  expression: "periods",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c("v-range-slider", {
                                staticClass: "align-center px-2 py-0",
                                attrs: {
                                  label: _vm.$t("finishingMap.minutes"),
                                  "thumb-label": "",
                                  min: _vm.rangeMinutes[0],
                                  max: _vm.rangeMinutes[1],
                                  step: "1",
                                  "hide-details": "",
                                  color: "secondary",
                                },
                                on: { input: _vm.updateShots },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text font-weight-bold body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.minutes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 subheader-font monospace-font",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      `(${_vm.rangeMinutes[0]} - ${_vm.rangeMinutes[1]})`
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1794521083
                                ),
                                model: {
                                  value: _vm.minutes,
                                  callback: function ($$v) {
                                    _vm.minutes = $$v
                                  },
                                  expression: "minutes",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex py-2",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c("v-range-slider", {
                            staticClass: "align-center px-2 py-0",
                            attrs: {
                              label: _vm.$t("game.gameThreat.threat"),
                              "thumb-label": "",
                              max: _vm.threatMax,
                              min: _vm.threatMin,
                              step: "0.01",
                              "hide-details": "",
                              color: "secondary",
                            },
                            on: { input: _vm.updateShots },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text font-weight-bold body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("game.gameThreat.threat")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 subheader-font monospace-font",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                `(${_vm.threatMax} - ${_vm.threatMin})`
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.threat,
                              callback: function ($$v) {
                                _vm.threat = $$v
                              },
                              expression: "threat",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.stackedView
                    ? _c(
                        "div",
                        { staticClass: "pb-2 px-1 mt-5" },
                        [_c("v-divider")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.stackedView
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex justify-end py-0 w-100 pr-1",
                          attrs: { id: "image-download" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsPNG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("PNG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsSVG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("SVG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingExport,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onGenerateIFrameClick()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("share")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Embed")]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-shrink-0 ml-2 align-self-start" },
                [_vm._t("filters-toggle")],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "chart",
              staticClass: "text-center",
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.showFilters ? 8 : 10,
                id: "chart",
              },
            },
            [
              _vm.player && _vm.avatarSize && _vm.mediaMode && _vm.size
                ? _c("PlayerAvatarMedia", {
                    ref: "playerAvatarMediaRef",
                    staticClass: "mt-2",
                    attrs: {
                      player: _vm.headerPlayer,
                      width: _vm.size,
                      height: _vm.avatarSize.height,
                      id: `${_vm.playerId}-${_vm.chartId}-xT`,
                      margin: _vm.margin,
                      title: _vm.mediaModeData.upperText,
                      subtitle: _vm.mediaModeData.lowerText,
                      color: _vm.mediaModeData.borderColor,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      comparisonTitle: _vm.mediaModeData.comparisonUpperText,
                      comparisonSubtitle: _vm.mediaModeData.comparisonLowerText,
                      comparisonColor: _vm.mediaModeData.comparisonBorderColor,
                      face: _vm.mediaModeData.face.dataUrl,
                      nationalTeam: _vm.mediaModeData.nationalTeam,
                      lineDistance: _vm.mediaModeData.lineLength,
                      lineWeight: _vm.mediaModeData.lineWeight,
                      avatarSize: _vm.mediaModeData.avatarSize,
                      upperTextFontSize: _vm.mediaModeData.upperTextFontSize,
                      upperTextFontWeight:
                        _vm.mediaModeData.upperTextFontWeight,
                      lowerTextFontSize: _vm.mediaModeData.lowerTextFontSize,
                      lowerTextFontWeight:
                        _vm.mediaModeData.lowerTextFontWeight,
                      fontFamily: _vm.mediaModeData.fontFamily,
                      type: "xTThreatMap",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.size != 0 && _vm.player !== null
                ? _c("XTChart", {
                    key: _vm.xtMap,
                    attrs: {
                      size: _vm.size,
                      type: _vm.type,
                      player: _vm.player,
                      plays: _vm.filteredShots,
                      minXT: _vm.threat[0],
                      maxXT: _vm.threat[1],
                      language: _vm.currentUserLanguage,
                      typeOfPlay: _vm.typeOfPlayModel,
                      seasons: _vm.filteredSeasons,
                      playerName: _vm.player.name,
                      circlesAndBoxes: _vm.checkboxCircles,
                      homeFillColor: _vm.mediaModeData.leftFillColor,
                      awayFillColor: _vm.mediaModeData.rightFillColor,
                      homeBorderColor: _vm.mediaModeData.leftBorderColor,
                      awayBorderColor: _vm.mediaModeData.rightBorderColor,
                      mediaMode: _vm.mediaMode,
                      id: `${_vm.playerId}-${_vm.chartId}`,
                      gameId: _vm.gameId,
                      gameIds: _vm.gamesModel,
                      gameName: _vm.gameName,
                      minsPlayed: _vm.minsPlayed,
                      fontFamily: _vm.mediaModeData.fontFamily,
                      teamId: _vm.teamId || 0,
                      filterActionEndingText: _vm.playerFilterActionEndingText,
                      filterMinutesText: _vm.filterMinutesText,
                    },
                    on: {
                      sizeChange: function ($event) {
                        return _vm.onChartSizeChange($event)
                      },
                      loaded: function ($event) {
                        return _vm.onLoaded($event)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.player &&
              _vm.avatarSize &&
              _vm.size &&
              _vm.mediaMode &&
              _vm.mediaModeData.socialMedia
                ? _c("DriblabSocialMedia", {
                    ref: "driblabSocialMediaRef",
                    attrs: {
                      width: _vm.size,
                      height: 50,
                      id: `${_vm.playerId}-${_vm.chartId}-xT`,
                      margin: _vm.margin,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      fontSize: _vm.mediaModeData.socialMediaFontSize,
                      fontWeight: _vm.mediaModeData.socialMediaFontWeight,
                      fontFamily: _vm.mediaModeData.fontFamily,
                      logoCfg: _vm.mediaModeData.logo,
                      sponsor: _vm.mediaModeData.sponsor.dataUrl,
                      type: "playerThreat",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.player
        ? _c("ChartExportLinksModal", {
            ref: "chartExportLinksModalRef",
            attrs: {
              title: _vm.player.name,
              subtitle: _vm.$t("playerDetail.threatMap"),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentUser.showTour &&
      _vm.playerSeasonData &&
      _vm.playerSeasonData.length
        ? _c("Tour", {
            attrs: { name: "playerThreatTour", steps: _vm.tourSteps },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }